import InnerHtml from '@elevio/kb-kit/lib/components/InnerHtml';
import { Helmet } from '@elevio/kb-kit/lib/components/meta';
import React, { Fragment } from 'react';
import { LoadingBar } from '../layout';
import { themeOptions } from '../variables/themeOptions';
// FUNCTIONS
export default function Page({ children }) {
    return (<Fragment>
      <LoadingBar />
      {children}
      {themeOptions.customCSS && (<Helmet>
          <style>{`${themeOptions.customCSS}`}</style>
        </Helmet>)}
      {themeOptions.customJS && (<InnerHtml html={`<script>${themeOptions.customJS}</script>`}/>)}
    </Fragment>);
}
